// extracted by mini-css-extract-plugin
module.exports = {"root":"Homepage_root__JsY6h","link":"Homepage_link__1_tbH","background-image":"Homepage_background-image__1sgVN"};